import Alert from '@eduzz/houston-ui/Alert';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { isIntegrationMelhorEnvio, isIntegrationActive } from '../../../../helpers';
import Input from './components/Input';
import { deepClone, redirectToMelhorEnvioAuth } from './helpers';
import { alertMessages, fieldHelpMessages } from './messages';
import { useStyles } from './styles';
import { schema, validate, isValid } from './validations';

import type { ActiveIntegrationResponse } from '../../../../types';
import type { AlertState } from './types';
import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  physicalDelivery: any;
  integration: ActiveIntegrationResponse;
}
const MelhorEnvio = ({ physicalDelivery, integration, dispatch }: IProps) => {
  const [alert, setAlert] = useState<AlertState>({
    visible: false,
  });
  const [validations, setValidations] = useState({});

  const classes = useStyles();
  const handleAlertExhibition = () => {
    if (!isIntegrationMelhorEnvio(integration)) {
      setAlert({
        visible: true,
        ...alertMessages.vinculate,
      });
      return;
    }

    if (!isIntegrationActive(integration)) {
      setAlert({
        visible: true,
        ...alertMessages.reactivate,
      });
      return;
    }
    setAlert({ visible: false });
  };

  const handleChangeDeliveryFields = async (key: string, value: any) => {
    const _physicalDelivery = deepClone(physicalDelivery);
    _physicalDelivery[key] = value;
    dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery: _physicalDelivery });

    const _validations = validate(_physicalDelivery, schema);
    setValidations(_validations);
  };

  const handleCloseAlert: () => void = () => setAlert({ ...alert, visible: false });

  useEffect(() => {
    handleAlertExhibition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [integration]);

  return (
    <div className={classes.container}>
      {alert.visible && (
        <div className={classes.alert}>
          <Alert
            type='warning'
            title={alert.title}
            onClose={handleCloseAlert}
            actionProps={{ text: alert.buttonText, onClick: () => redirectToMelhorEnvioAuth(handleCloseAlert) }}
            visible={alert.visible}
          >
            {alert.description}
          </Alert>
        </div>
      )}
      <div className={classes.fields}>
        <Input
          label='Peso do produto'
          id='weight'
          mask='money'
          helperText={fieldHelpMessages['weight']}
          error={isValid(validations, 'weight')}
          value={physicalDelivery.weight}
          onChange={(value) => handleChangeDeliveryFields('weight', value)}
          endAdornment='kg'
        />
        <Input
          label='Altura do produto'
          id='height'
          mask='number'
          helperText={fieldHelpMessages['height']}
          error={isValid(validations, 'height')}
          value={physicalDelivery.height}
          onChange={(value) => handleChangeDeliveryFields('height', value)}
        />
        <Input
          label='Largura do produto'
          id='width'
          mask='number'
          helperText={fieldHelpMessages['width']}
          error={isValid(validations, 'width')}
          value={physicalDelivery.width}
          onChange={(value) => handleChangeDeliveryFields('width', value)}
        />
        <Input
          label='Comprimento do produto'
          id='length'
          mask='number'
          helperText={fieldHelpMessages['length']}
          error={isValid(validations, 'length')}
          value={physicalDelivery.length}
          onChange={(value) => handleChangeDeliveryFields('length', value)}
        />
      </div>
    </div>
  );
};
function mapStateToProps(state: any) {
  return {
    physicalDelivery: state.components.physicalDelivery,
  };
}

export default connect(mapStateToProps)(MelhorEnvio) as any;
